import { render } from "./CorporateNameList.vue?vue&type=template&id=0596b3ad&scoped=true"
import script from "./CorporateNameList.vue?vue&type=script&lang=js"
export * from "./CorporateNameList.vue?vue&type=script&lang=js"

import "./CorporateNameList.vue?vue&type=style&index=0&id=0596b3ad&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0596b3ad"]])

export default __exports__